// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../home/tiger/.nvm/versions/node/v12.4.0/lib/node_modules/@ies/eden/node_modules/@ies/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1xSOAQ-p8d79xyo1tHEwxJ{position:fixed;bottom:38px;left:50%;z-index:10;transform:translateX(-50%);background:#55beb0;box-shadow:0 2px 4px rgba(0,0,0,0.11);border-radius:50px;height:.92rem;line-height:.92rem;padding:0 0.88rem;align-items:center;font-weight:600;font-size:16px;color:#fff;white-space:nowrap}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": "_1xSOAQ-p8d79xyo1tHEwxJ"
};
module.exports = ___CSS_LOADER_EXPORT___;
